(() => {
  angular
    .module('gm.common.directives')
    .directive('btgDropdownCurrency', btgDropdownCurrencyDirective);

  function btgDropdownCurrencyDirective(
    $filter,
    GmyCurrencies
  ) {
    'ngInject';

    return {
      restrict: 'E',
      require: 'ngModel',
      templateUrl: 'modules/common/directives/dropdown-currency/dropdown-currency.html',
      scope: {
        isOpen: '=',
        allow: '=?',
        exclude: '=?',
        flyout: '@'
      },

      link(scope, _element, _attrs, ctrl) {
        const currencyHash = GmyCurrencies.getCurrencyHash();
        let currencyList = [];

        scope.$sc = scope;
        scope.activeCurrency = null;
        scope.showAsList = false;
        scope.filterInput = '';
        scope.filteredCurrencyList = [];
        scope.topCountries = [];
        scope.groupedCountries = [];

        function _initCountryLists(allow, exclude) {
          const topCountries = GmyCurrencies.getTopCountries(allow, exclude);
          const groupedCountries = GmyCurrencies.getCountriesByGroups(allow, exclude);

          currencyList = GmyCurrencies.getCurrencies(allow, exclude);

          scope.filteredCurrencyList = prepareCurrencyListForMenu(currencyList);
          scope.topCountries = prepareCurrencyListForMenu(topCountries);
          scope.groupedCountries = Object.keys(groupedCountries)
            .reduce((result, continent) => {
              result[continent] = prepareCurrencyListForMenu(groupedCountries[continent]);
              return result;
            }, {});

          scope.showAsList = allow && allow.length > 0;
        }

        _initCountryLists(scope.allow, scope.exclude);

        // for search
        scope.$watch('filterInput', (filterInput) => {
          const filteredList = filterInput
            ? $filter('filter')(currencyList, filterInput)
            : currencyList;

          scope.filteredCurrencyList = prepareCurrencyListForMenu(filteredList);
        });

        scope.setActiveCode = (currencyCode) => {
          scope.activeCurrency = currencyHash[currencyCode];
          scope.isOpen = false;
        };

        scope.$watchCollection('allow', allow => _initCountryLists(allow, scope.exclude));
        scope.$watchCollection('exclude', exclude => _initCountryLists(scope.allow, exclude));
        scope.$watch('isOpen', () => { scope.filterInput = ''; });

        scope.$watch('activeCurrency', currency => ctrl.$setViewValue(currency));

        ctrl.$render = () => { scope.activeCurrency = ctrl.$viewValue; };
      }
    };

    function prepareCurrencyListForMenu(list) {
      return list.map(c => ({
        id: c.code,
        flag: c.flag,
        name: c.name,
        meta: c.code
      }));
    }
  }
})();
